"use client";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NavLink } from "@/components/ui/nav-link";
import { hexToRgba } from "@/lib/utils";

interface MobileMenuProps {
  items: Array<{
    label: string;
    href: string;
  }>;
  styling?: {
    allCaps?: boolean;
    fontWeight?: string;
    letterSpacing?: string;
    activeClass?: string;
  };
  overlayColor: string;
  enableAnimations: boolean;
}

export function MobileMenu({
  items,
  styling,
  overlayColor,
  enableAnimations,
}: MobileMenuProps) {
  const [open, setOpen] = useState(false);

  const menuInner = (
    <>
      <button
        aria-label="Close menu"
        className="ml-auto mb-4"
        onClick={() => setOpen(false)}
      >
        <X className="h-6 w-6" />
      </button>
      {items.map((item) => (
        <NavLink
          key={item.href}
          item={item}
          styling={styling}
          onClick={() => setOpen(false)}
          className="py-2"
        />
      ))}
    </>
  );

  return (
    <div className="md:hidden">
      <button aria-label="Open menu" onClick={() => setOpen(true)} className="p-2">
        <Menu className="h-6 w-6" />
      </button>
      {enableAnimations ? (
        <AnimatePresence>
          {open && (
            <div
              className="fixed inset-0 backdrop-blur-sm z-50"
              style={{ backgroundColor: hexToRgba(overlayColor, 0.8) }}
            >
              <motion.div
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                className="ml-auto w-64 bg-card shadow-lg p-6 flex flex-col gap-4 h-fit bg-muted"
              >
                {menuInner}
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      ) : (
        open && (
          <div
            className="fixed inset-0 backdrop-blur-sm z-50"
            style={{ backgroundColor: hexToRgba(overlayColor, 0.8) }}
          >
            <div className="ml-auto h-full w-64 bg-card shadow-lg p-6 flex flex-col gap-4">
              {menuInner}
            </div>
          </div>
        )
      )}
    </div>
  );
}
